export const margin = 6

// Z-Indexes
export const modalZIndex = 2147483646

export const fontFamily = {
    title: 'nexablack, sans-serif',
    body: 'interface, Helvetica Neue, helvetica, sans-serif;',
}
